import Api from './baseApi';

export default {
  searchPartnerBanks: (params) => {
    let url = '/api/partnerbanks?v=1';
    if (params.search) url += `&q=${params.search}`;
    if (params.status) url += `&status=${params.status}`;
    if (params.tenantId) url += `&tenantId=${params.tenantId}`;
    return Api.get(url);
  },
  getAllPartnerBanks: () => Api.get('/api/partnerbanks/all'),
  getPartnerBank: (id) => Api.get(`/api/partnerbanks/${id}`),
  putPartnerBank: (bank) => Api.put(`/api/partnerbanks/${bank.id}`, bank),
  deletePartnerBank: (bank) => Api.delete(`/api/partnerbanks/${bank.id}`),
  postPartnerBank: (bank) => Api.post(`/api/partnerbanks`, bank),
  cashAmountUpdate: (bankName, cashAmount) =>
    Api.post(`/api/partnerbanks/cash-amount-update`, { bankName, cashAmount }),
};
